import { HelpCentreSearchBar } from "~/lib/components/search-bar/help-centre-search-bar";

const Hero = () => {
  return <HelpCentreSearchBar />;
};
export default Hero;
